




































import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import filtersList from '@/components/Newsletters/filtersList.vue'
import activeTable from '@/components/Ui/ActiveTable/ActiveTable.vue'
import rcptTableConfig from '@/activeTables/polls/recipients'
import Poll from '@/models/polls/Poll'
import {MAILING_STATUS_PROGRESS, MAILING_STATUS_COMPLETED} from '@/constants'
import Vue from 'vue'
import User from '@/models/Users/User'
export default Vue.extend({
  props: {
    scope: {} as () => {poll: Poll},
    options: {}
  },
  components: {
    infoRowsBlock,
    filtersList
  },
  data () {
    return {
      pageBaseUrl: `/polls/${this.$route.params.id}/rcpts`,
      loaded: false,
      vissibleIdsList: false,
      vissibleFiltersList: false,
      rcptTableConfig,
      interval: null
    }
  },
  computed: {
    status (): string {
      return this.scope.poll.getStatus();
    },
    ts (): number {
      return this.scope.poll.getTs();
    },
    serverTime (): number {
      return this.$store.state.serverTime;
    },
    user (): User | false {
      return this.$store.state.user.user
    }
  },
  methods: {
    async toggleList (): Promise<void> {
      if (!this.loaded) {
        // @ts-ignore
        let byId = await this.$refs.rcptById.loadList()
        // @ts-ignore
        let byFilter = await this.$refs.rcptByFilter.loadList()
        this.vissibleIdsList = !!byId.count;
        this.vissibleFiltersList = !!byFilter.count;
        this.loaded = true;
      } else {
        this.vissibleIdsList = false;
        this.vissibleFiltersList = false;
        this.loaded = false;
      }
    },
    dataWatcher (): void {
      // @ts-ignore
      let self = this;
      // @ts-ignore
      self.interval = setInterval(() => {
        let timeDiff = this.serverTime - this.ts;
        if (self.status === MAILING_STATUS_PROGRESS || self.status === MAILING_STATUS_COMPLETED && timeDiff < 7200000) {
          if (this.user) {
            // @ts-ignore
            self.reloadData();
          }
        }
      }, 2000)
    },
    async reloadData (): Promise<void> {
      // @ts-ignore
      await this.$refs.rcptById.loadList()
      // @ts-ignore
      await this.$refs.rcptByFilter.loadList()
    },
    clearInterval (): void {
      // @ts-ignore
      clearInterval(this.interval)
    }
  },
  async mounted () {
    setTimeout(() => {
      this.toggleList();
    }, 200);
    this.dataWatcher();
    this.$root.$on('relogin', this.clearInterval)
  },
  beforeDestroy () {
    this.clearInterval()
    this.$root.$off('relogin', this.clearInterval)
  },
  watch: {
    status (newVal, oldVal) {
      /* if (newVal !== oldVal && newVal === MAILING_STATUS_COMPLETED) {
        this.reloadData();
      } */
    }
  }
})
